<template>
    <div class="g-container-box">
        <el-row class="g-header-container">
            <el-col :span="3">
                <div class="g-header-left">熟客控制台</div>
            </el-col>
            <el-col :span="16">
                <nav-head navSel="4"></nav-head>
            </el-col>
            <el-col :span="5">
                <op-head></op-head>
            </el-col>
        </el-row>
        <el-row class="g-view-container">
            <el-col :span="3" class="g-menu-container">
                <sidebar navType="4" defaultSel="2"></sidebar>
            </el-col>
            <el-col :span="21" class="g-center-container">

                <p class="smi_back" @click="backList">< 返回上一页</p>

                <div class="smi_model">
                    <p class="m_tit">订单详情</p>
                    <p class="m_li">
                        <span>提交时间：</span>
                        <span>{{listData.createTime}}</span>
                    </p>
                    <p class="m_li">
                        <span>订单号：</span>
                        <span>{{listData.serial}}</span>
                    </p>
                    <p class="m_li">
                        <span>物流状态：</span>
                        <span v-if="listData.orderState == 'wait'">待发货</span>
                        <span v-if="listData.orderState == 'send'">发货中</span>
                        <span v-if="listData.orderState == 'receive'">已收件</span>
                        <span v-if="listData.orderState == 'finish'">已完结</span>
                        <span v-if="listData.orderState == 'refund'">已退货</span>
                    </p>
                    <p class="m_li">
                        <span>收货人：</span>
                        <span>{{ listData.name }}</span>
                    </p>
                    <p class="m_li">
                        <span>收件地址：</span>
                        <span>{{listData.addr}}</span>
                    </p>
                </div>
                <div class="smi_model">
                    <p class="m_tit">结算详情</p>
                    

                    <el-table :data="listInfo" style="width: 100%" class="bmo_tab">
                        <el-table-column label="相册" width="400">
                            <template slot-scope="scope">
                                
                                <div class="col_li">
                                    <div class="mdb_pic">
                                        <div class="pic_img">
                                            <img :src="JSON.parse(scope.row.commodityPhoto)[0]">
                                        </div>
                                        <div class="pic_info">
                                            <p class="info_tit">{{ scope.row.commodityName }}</p>
                                            <p><span>货号：</span>{{ scope.row.commodityCode }}</p>
                                        </div>
                                    </div>
                                </div>

                            </template>
                        </el-table-column>
                        <el-table-column prop="price" label="牌价"></el-table-column>
                        <el-table-column label="数量">
                            <template slot-scope="scope">
                                <p>x1</p>
                            </template>
                        </el-table-column>
                    </el-table>

                </div>
                <div class="smi_model">
                    <p class="m_tit">交付物流</p>
                    <p class="m_tip">
                        <span v-if="wlList==''">物流公司：暂无信息</span>
                        <span v-else>物流公司：{{ wlList.expName }}</span>
                        <span v-if="wlList==''">运单号码：暂无信息</span>
                        <span v-else>运单号码：{{ wlList.number }}</span>
                    </p>
                    <p class="m_no" v-if="wlList==''">暂无物流信息！</p>
                    <div class="boc_box" v-else>
                        <div class="boc_item" v-for="(item, index) in wlList.list" :key="index">
                            <div class="item_line" :class="index == 0 ? 'color_orange' : ''"></div>
                            <div class="item_text" :class="index == 0 ? 'text_orange' : ''">{{item.status}}</div>
                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>
  
<script>

var util = require("@/common/util.js");
import { API_LOOKWL } from "../../assets/js/api.js";
import sidebar from '../../components/sidebar'
import navHead from "../../components/navHead";
import opHead from "../../components/opHead.vue";
export default {
    components: {
        sidebar,
        navHead,
        opHead
    },
    data() {
        return {
            listData: {},
            listInfo: [],
            dialog: false,
            status: '1',  // 1通过，2拒绝
            reco: '0',  // 0不推，1推荐
            isFreeze: '0', // 0不冻结，1推荐

            commodityId: '',
            merchantId: '',
            wlList: ''
        }
    },
    created() {
        this.getListData()
    },
    methods: {
        getListData() {
            this.listData = JSON.parse(localStorage.getItem("orderInfo"));
            this.listInfo.push(this.listData)
            this.getWlInfo()
        },
        backList() {
            this.$router.push({ path: '/order' });
        },
        getWlInfo(){
            let params = new URLSearchParams();
            params.append('no', this.listData.waybill);
            params.append('type', this.listData.logistics);
            util.getData(API_LOOKWL, params, (res) => {
                this.wlList = res.data.data
            })
        }
    }
}
</script>
  
<style lang="less">
.g-container-box {
    overflow: hidden;
}

.g-header-left {
    background-color: #5c6be8;
    color: #FFF;
    height: 60px;
    line-height: 60px;
    text-align: center;
}

.g-menu-container {
    height: 800px;
    background-color: #fff;
}

.g-header-right {
    background-color: #5c6be8;
    color: #FFF;
    padding-right: 40px;
    height: 60px;
    line-height: 60px;
    text-align: right;
}

.g-header-right span {
    margin: 0 10px;
    cursor: pointer;
}

.g-center-container {
    overflow: auto;
    height: 800px;
    background-color: #eff3f6;
    padding: 20px;
}

.smi_back {
    cursor: pointer;
    color: #78858E;
    margin-bottom: 20px;
}

.smi_model {
    background-color: #fff;
    padding: 16px;
    border-radius: 4px;
    margin-bottom: 20px;

    .m_tit {
        font-size: 16px;
        font-weight: 700;
        padding-bottom: 10px;
    }

    .m_li {
        padding-bottom: 6px;
        color: #666;

        span:first-child {
            width: 80px;
            display: inline-block;
            text-align: right;
        }
    }

    .m_tip{
        color: #666;
        border-bottom: 1px solid #f2f2f2;
        padding: 6px 0 16px;
        span{
            margin-right: 30px;
        }
    }
    .m_no{
        line-height: 160px;
        text-align: center;
        font-size: 16px;
        color: #888;
    }
    .boc_box{
        padding: 10px 0;
        .boc_item{
            padding: 10px 0;
            color: #78858E;
            display: flex;
            flex-direction: row;
            align-items: center;
            .item_line{
                width: 8px;
                height: 8px;
                border-radius: 4px;
                margin: 0 10px;
                background-color: #bbb;
            }
            .color_orange{
                background-color: #FF9D00;
            }
            .text_orange{
                color: #FF9D00;
            }
            .item_text{
                flex: 1;
            }
        }
    }
}
.col_li {
    flex: 1;
    .mdb_pic {
        display: flex;
        align-items: center;
        flex-direction: row;
        width: 260px;
        .pic_img {
            width: 80px;
            height: 80px;
            margin-right: 8px;
            border-radius: 4px;
            overflow: hidden;
            border: 1px solid #e7e7e7;
            img {
                width: 100%;
                height: auto;
            }
        }
        .pic_info {
            flex: 1;
            height: 80px;
            .info_tit {
                padding-bottom: 10px;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/odInfo/index.vue